import React, { Fragment, useState, useRef } from 'react'
import { CopyToClipboard } from 'react-copy-to-clipboard'
import styled from 'styled-components'
import copy from 'assets/images/social/copy-content.svg'
import Overlay from 'react-bootstrap/Overlay'
import Button from 'react-bootstrap/Button'
import FormControl from 'react-bootstrap/FormControl'
import Image from 'react-bootstrap/Image'
import Tooltip from 'react-bootstrap/Tooltip'
import PropTypes from 'prop-types'

const EventTitle = styled.h5``
const FormControlInput = styled(FormControl)`
  width: 100%;
  padding: 1.5em 0.7em;
  background: white;
  display: inline-block;
`
export default function EventContainer(props) {
  const { event, makeTitle } = props
  const target = useRef(null)
  const [tooltipOpen, setTooltipOpen] = useState(false)
  const [show, setShow] = useState(false)
  const copyPromoCode = eventSlug => {
    if (eventSlug) {
      setTooltipOpen(true)
      setTimeout(() => {
        setTooltipOpen(false)
      }, 1000)
    } else {
      setTooltipOpen(true)
      setTimeout(() => {
        setTooltipOpen(false)
      }, 1000)
    }
  }

  return (
    <Fragment>
      <EventTitle className="mb-4">{makeTitle(event.event_slug)}</EventTitle>
      <Overlay target={target.current} show={tooltipOpen}>
        {props => (
          <Tooltip placement="top" {...props}>
            Copied to clipboard
          </Tooltip>
        )}
      </Overlay>
      <CopyToClipboard
        text={event.event_referral_url}
        onCopy={() => copyPromoCode(event.event_slug)}
      >
        <FormControlInput
          className="mr-2 mb-2"
          value={event.event_referral_url}
          id={'refURLTextBox' + event.event_slug}
          disabled
        />
      </CopyToClipboard>
      <CopyToClipboard
        text={event.event_referral_url}
        onCopy={() => copyPromoCode(event.event_slug)}
      >
        <Button
          ref={target}
          onClick={() => setShow(!show)}
          variant="light"
          size="sm"
          className="mt-4 mt-md-0 cursor-pointer shadow-sm mr-2"
        >
          <Image src={`${copy}`} alt={'Gmail'} width="20px" height="20px" />
        </Button>
      </CopyToClipboard>
    </Fragment>
  )
}

EventContainer.propTypes = {
  event: PropTypes.object,
  makeTitle: PropTypes.func,
}
